import React from "react";
import ContactInformation from "../components/contactInformation/contactInformation";

export default function ContactInformationRouter() {
  return <ContactInformation />;
}
